import { useState } from "react";
import { IPractice } from "../types/generalTypes";
import { PracticesContext } from "./contextExporter";

export function PracticesContextProvider({
  children,
  practices,
  onComplete,
}: {
  children: React.ReactNode;
  practices: IPractice[];
  onComplete?: () => void;
}) {
  const [practiceIndex, setPracticeIndex] = useState(0);

  const activePractice = practices[practiceIndex];
  const nextPractice = () =>
    practiceIndex === practices.length - 1
      ? onComplete?.()
      : setPracticeIndex((prev) => prev + 1);
  const prevPractice = () =>
    practiceIndex === 0 ? null : setPracticeIndex((prev) => prev - 1);

  return (
    <PracticesContext.Provider
      value={{
        practices,
        activePractice,
        setPracticeIndex,
        practiceIndex,
        nextPractice,
        prevPractice,
        isFirstPractice: practiceIndex === 0,
        isLastPractice: practiceIndex === practices.length - 1,
      }}
    >
      {children}
    </PracticesContext.Provider>
  );
}
